/**
 * Bootstrap da aplicação
 * Centraliza a inicialização de todos os módulos
 */

import { setupRouter, initializeRouter } from './router-setup';
import { initializeGA4, setupGA4Debug } from '../utils/ga4.util';
import { logger } from '../utils/logger.util';

/**
 * Inicializa a aplicação
 * Nota: Estilos são importados diretamente no main.ts (processados em build time pelo Vite)
 */
export async function bootstrap(): Promise<void> {
  logger.logWithContext('Bootstrap', 'Inicializando aplicação...');
  
  try {
    // Inicializar Google Analytics 4
    initializeGA4();
    setupGA4Debug(); // Configurar função de debug
    
    // Configurar rotas
    setupRouter();
    logger.logWithContext('Bootstrap', 'Rotas configuradas');
    
    // Inicializar roteamento
    initializeRouter();
    logger.logWithContext('Bootstrap', 'Roteamento inicializado');
    
    logger.logWithContext('Bootstrap', 'Aplicação inicializada com sucesso');
  } catch (error) {
    logger.error('[Bootstrap] Erro ao inicializar aplicação:', error);
    throw error;
  }
}
